import { Pipe, PipeTransform } from '@angular/core';
import { EspecificacaoHelper } from 'src/app/core/helpers/especificacao.helper';

@Pipe({
  name: 'especificacaoTitulo',
})
export class EspecificacaoTituloPipe implements PipeTransform {
  transform(titulo: string, codigo: number | null | undefined): string {
    return EspecificacaoHelper.tituloComCodigo(codigo, titulo);
  }
}
